import { SwiperModule } from 'swiper/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { BtnComponent } from '../../partials/btn/btn.component';
import { PartialsModule } from '../../partials/partials.module';
import { CoreModule } from './../../../core/core.module';
import { BookListComponent } from './book-list/book-list.component';
import { ExamComponent } from './exam/exam.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home/home.component';
import { CourseListBottomSheetComponent } from './home/course-list-bottom-sheet/course-list-bottom-sheet.component';
import { ReportVideoBottomSheetComponent } from './course-list/course-video-detail/report-video-bottom-sheet/report-video-bottom-sheet.component';
import { SwiperComponent } from '../../partials/swiper/swiper.component';

@NgModule({
  declarations: [
    BookListComponent,
    HomeComponent,
    ExamComponent,
    BtnComponent,
    CourseListBottomSheetComponent,
    ReportVideoBottomSheetComponent,
  ],
  imports: [
    CommonModule,
    PartialsModule,
    HomeRoutingModule,
    CarouselModule,
    CoreModule,
    NgbCarouselModule,
    MatMenuModule,
    SwiperModule,
    NgxSkeletonLoaderModule,
  ]
})
export class HomeModule {
}
